import ErrorDialog from './Error'
import ErrorDialogContent from './ErrorContent'
import LoaderDialog from './Loader'
import LoaderDialogContent from './LoaderContent'

/**
 *
 */
export {
    ErrorDialog,
    ErrorDialogContent,
    LoaderDialog,
    LoaderDialogContent
}
